import reduxStore from '../reduxStore';

export default function authHeader() {
  const authState = reduxStore.getState().auth;
  return authState.isAuthenticated && authState.token
    ? `Bearer ${authState.token}`
    : '';
}
